import {emailSchema, getSchemaKeys, ImportUserHeaderCSVSchema} from '../../../../incase-domain/validators/user/importUserCSV';
import i18n from '../../../../i18n';

export const importUsersCSVParser = (
    file: File,
    setErrorMsg: (msg: string) => void,
    setImportUserModal: (open: boolean) => void,
    setErrorModal: (open: boolean) => void
): Promise<boolean> => {
    return new Promise((resolve) => {
        const reader = new FileReader();

        if (!file.name.toLowerCase().endsWith('.csv')) {
            setErrorMsg(i18n.t('toasts.importTypeFailed'));
            setErrorModal(true);
            throw new Error();
        }

        reader.onload = (event) => {
            setImportUserModal(true);
            const text = event.target?.result as string;
            const lines = text.split('\n');
            const headers = lines[0].split(',').map((header) => header.trim().toLowerCase());
            const importUsersCSVSchemaKeys = getSchemaKeys(ImportUserHeaderCSVSchema);

            try {
                if (headers[0] !== 'email') {
                    setErrorMsg(i18n.t('registerPage.importUsers.headerErrors.wrongHeader'));
                    throw new Error();
                }

                if (headers.length > 1) {
                    if (!headers.includes('username') && !headers.includes('password')) {
                        setErrorMsg(i18n.t('registerPage.importUsers.headerErrors.wrongHeader'));
                        throw new Error();
                    }
                }

                if (headers.length > importUsersCSVSchemaKeys.length) {
                    setErrorMsg(i18n.t('registerPage.importUsers.headerErrors.wrongHeader'));
                    throw new Error();
                }

                const headerObject = {
                    email: headers.includes('email') ? 'email' : undefined,
                    username: headers.includes('username') ? 'username' : undefined,
                    password: headers.includes('password') ? 'password' : undefined,
                };

                const filteredHeaders = Object.fromEntries(
                    Object.entries(headerObject).filter(([key, value]) => key !== undefined && value !== undefined)
                );

                if (Object.keys(filteredHeaders).length !== headers.length) {
                    setErrorMsg(i18n.t('registerPage.importUsers.headerErrors.wrongHeader'));
                    throw new Error();
                }
                ImportUserHeaderCSVSchema.parse(filteredHeaders);

                for (let i = 1; i < lines.length; i++) {
                    const cells = lines[i].split(',').map((cell) => cell.trim());
                    const emailIndex = headers.indexOf('email');
                    if (emailIndex !== -1 && cells[emailIndex]) {
                        try {
                            emailSchema.parse(cells[emailIndex]);
                        } catch {
                            setErrorMsg(`${i18n.t('registerPage.importUsers.emailError')} ${i + 1}: ${cells[emailIndex]}`);
                            throw new Error();
                        }
                    }
                }
                return resolve(true);
            } catch (error) {
                setImportUserModal(false);
                setErrorModal(true);
                throw new Error();
            }
        };

        reader.readAsText(file);
    });
};
